import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import "../Cluster/cluster.css"
import { allocateDoor } from './actions'
import AddClusterEasyAccess from "./AddClusterEasyAccess"

class UnallocatedDoor extends Component {
    render() {

        const { lock, door, key } = this.props

        return (
            <div className="cluster-box-unallocated">
                <div className="cluster-box-title">
                    <b>{door.display_name ? door.display_name : "Paketbox " + (key + 1)}</b>
                </div>
                <hr style={{ width: "95%" }} />
                <div className="cluster-box-status">
                    Status: <span style={{ fontWeight: "bold", color: "#008b97" }}>Ledig</span>
                </div>
                <div style={{ margin: "auto" }}>
                    <AddClusterEasyAccess style={{ margin: "inherit" }} allocateDoor={this.props.allocateDoor} lock={lock} door={door} />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
    }
}

const mapDispatchToProps = dispatch => {
    return {
        allocateDoor: (door_id, lockid, obj) => dispatch(allocateDoor(door_id, lockid, obj)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UnallocatedDoor)